import logger from "@ane/core/lib/services/logging/Logger";
import ___default from "lodash";
import { ofType, combineEpics } from "redux-observable";
import { tap, ignoreElements, filter, map } from "rxjs/operators";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { setOverviewMainFunctionality, setProgressionsMainFunctionality, setOverviewFullLoad, setProgressionsFullLoad, setProgressionsScorecardsFullLoad, setAlertsFullLoad, mainFunctionality as mainFunctionality$1, fullLoad as fullLoad$1 } from "./FeatureRolloutLogPerformanceActions.js";
import FeatureRolloutLogPerformanceConstants from "./FeatureRolloutLogPerformanceConstants.js";
const loadStart = (action$) => {
  return action$.pipe(
    ofType(FeatureRolloutLogPerformanceConstants.LOAD_START),
    tap((action) => logger.trackMetric({ average: action.payload.clientTimeInMs, name: `PLT:${action.type}`, properties: {} })),
    // ignoreElements: This epic only needs to log LOAD_START, so we don't need to pipe any additional actions
    ignoreElements()
  );
};
const mapCheckMarkToStoreAndAction = {
  [FeatureRolloutLogPerformanceConstants.CHECK_OVERVIEW_MAIN_FUNCTIONALITY]: {
    storeName: "overviewMainFunctionalityClientTime",
    setAction: setOverviewMainFunctionality
  },
  [FeatureRolloutLogPerformanceConstants.CHECK_PROGRESSIONS_MAIN_FUNCTIONALITY]: {
    storeName: "progressionsMainFunctionalityClientTime",
    setAction: setProgressionsMainFunctionality
  },
  [FeatureRolloutLogPerformanceConstants.CHECK_OVERVIEW_FULL_LOAD]: {
    storeName: "overviewFullLoadClientTime",
    setAction: setOverviewFullLoad
  },
  [FeatureRolloutLogPerformanceConstants.CHECK_PROGRESSIONS_FULL_LOAD]: {
    storeName: "progressionsFullLoadClientTime",
    setAction: setProgressionsFullLoad
  },
  [FeatureRolloutLogPerformanceConstants.CHECK_PROGRESSIONS_SCORECARDS_FULL_LOAD]: {
    storeName: "progressionsScorecardFullLoadClientTime",
    setAction: setProgressionsScorecardsFullLoad
  },
  [FeatureRolloutLogPerformanceConstants.CHECK_ALERTS_FULL_LOAD]: {
    storeName: "alertsFullLoadClientTime",
    setAction: setAlertsFullLoad
  }
};
const checkActions = ___default.keys(mapCheckMarkToStoreAndAction);
const checkStoreForPltMark = (action$, state$) => {
  return action$.pipe(
    ofType(...checkActions),
    filter((action) => {
      const config = mapCheckMarkToStoreAndAction[action.type];
      if (!config) {
        throw new Error(`action not supported in checkStoreForPltMark: ${action.type}`);
      }
      return state$.value.featureRolloutLogPerformance[config.storeName] === null;
    }),
    map((action) => {
      const config = mapCheckMarkToStoreAndAction[action.type];
      return config.setAction(action.payload.clientTimeInMs);
    })
  );
};
const mainFunctionality = (action$, state$) => {
  return action$.pipe(
    ofType(
      FeatureRolloutLogPerformanceConstants.SET_OVERVIEW_MAIN_FUNCTIONALITY,
      FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_MAIN_FUNCTIONALITY
    ),
    tap((action) => {
      const loadStartTimeInMs = state$.value.featureRolloutLogPerformance.pageLoadClientTime;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - loadStartTimeInMs;
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `PLT:${action.type}`,
        properties: { timeSinceLoadStartInMs, loadStartTimeInMs }
      });
    }),
    // if ALL MFL values are sent then emit MAIN_FUNCTIONALITY
    filter(() => {
      return !!state$.value.featureRolloutLogPerformance.progressionsMainFunctionalityClientTime && !!state$.value.featureRolloutLogPerformance.overviewMainFunctionalityClientTime;
    }),
    tap((action) => {
      const loadStartTimeInMs = state$.value.featureRolloutLogPerformance.pageLoadClientTime;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - loadStartTimeInMs;
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `PLT:${FeatureRolloutLogPerformanceConstants.MAIN_FUNCTIONALITY}`,
        properties: { timeSinceLoadStartInMs, lastPartToLoad: action.type, loadStartTimeInMs }
      });
    }),
    map((action) => {
      return mainFunctionality$1(
        action.payload.clientTimeInMs - state$.value.featureRolloutLogPerformance.pageLoadClientTime,
        action.type
      );
    })
  );
};
const fullLoad = (action$, state$) => {
  return action$.pipe(
    ofType(
      FeatureRolloutLogPerformanceConstants.SET_OVERVIEW_FULL_LOAD,
      FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_FULL_LOAD,
      FeatureRolloutLogPerformanceConstants.SET_PROGRESSIONS_SCORECARDS_FULL_LOAD,
      FeatureRolloutLogPerformanceConstants.SET_ALERTS_FULL_LOAD
    ),
    tap((action) => {
      const loadStartTimeInMs = state$.value.featureRolloutLogPerformance.pageLoadClientTime;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - loadStartTimeInMs;
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `PLT:${action.type}`,
        properties: { timeSinceLoadStartInMs, loadStartTimeInMs }
      });
    }),
    // if ALL Full Load values are sent then emit FULL_LOAD
    filter(() => {
      return !!state$.value.featureRolloutLogPerformance.overviewFullLoadClientTime && !!state$.value.featureRolloutLogPerformance.progressionsFullLoadClientTime && !!state$.value.featureRolloutLogPerformance.progressionsScorecardFullLoadClientTime && (EnvironmentService.isUnifiedView && !EnvironmentService.loadSingleStageAlerts() || EnvironmentService.enableBatchAlertsAPICall() ? !!state$.value.featureRolloutLogPerformance.alertsFullLoadClientTime : true);
    }),
    tap((action) => {
      const loadStartTimeInMs = state$.value.featureRolloutLogPerformance.pageLoadClientTime;
      const timeSinceLoadStartInMs = action.payload.clientTimeInMs - loadStartTimeInMs;
      logger.trackMetric({
        average: timeSinceLoadStartInMs,
        name: `PLT:${FeatureRolloutLogPerformanceConstants.FULL_LOAD}`,
        properties: { timeSinceLoadStartInMs, lastPartToLoad: action.type, loadStartTimeInMs }
      });
    }),
    map((action) => {
      return fullLoad$1(
        action.payload.clientTimeInMs - state$.value.featureRolloutLogPerformance.pageLoadClientTime,
        action.type
      );
    })
  );
};
const featureRolloutLogPerformanceEpics = combineEpics(loadStart, checkStoreForPltMark, mainFunctionality, fullLoad);
export {
  checkStoreForPltMark,
  featureRolloutLogPerformanceEpics,
  fullLoad,
  loadStart,
  mainFunctionality
};
//# sourceMappingURL=FeatureRolloutLogPerformanceEpics.js.map
